module.exports = __webpack_public_path__ + "img/makerImg.77894b85.png";